let SecurityControl;

import AuthStore from 'bz-stores/lib/auth-store';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import { computed } from 'mobx';
import React from 'react';
import { cache } from 'tm3-core/cache';
export default (SecurityControl = createReactClass({
  displayName: 'SecurityControl',

  getDefaultProps() {
    return {
      action: '',
      actions: [],
      message: <span />,
      fallback: <span />
    };
  },

  getInitialState() {
    if (this.props.action !== '') {
      cache.permissions.canDoAction(this.props.action, AuthStore.user.location.id);
    }
    if (this.props.actions.length > 0) {
      this.props.actions.forEach((action: string) => {
        return cache.permissions.canDoAction(action, AuthStore.user.location.id);
      });
    }
    return {};
  },

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (
      this.props.action.toString() !== nextProps.action.toString() ||
      this.props.actions.toString() !== nextProps.actions.toString() ||
      this.props.location !== nextProps.location ||
      nextState.defaultLocation !== this.state.defaultLocation
    ) {
      if (nextProps.action !== '') {
        cache.permissions.canDoAction(nextProps.action, nextProps.location);
      }
      if (nextProps.actions.length > 0) {
        return nextProps.actions.forEach((action) => {
          return cache.permissions.canDoAction(action, nextProps.location);
        });
      }
    }
  },

  formRule(action) {
    return ((this.props.location || this.state.defaultLocation) + action).replace(/\//g, '-');
  },

  canDoAction(action) {
    return cache.permissions.canDoAction(action, AuthStore.user.location.id);
  },

  canDoRule() {
    if (this.props.action !== '') {
      return this.canDoAction(this.props.action);
    } else if (this.props.actions.length > 0) {
      let can = true;
      this.props.actions.forEach((action) => {
        if (can) {
          if (this.canDoAction(action)) {
            return (can = true);
          } else {
            return (can = false);
          }
        }
      });
      return can;
    }
  },

  render() {
    return this.result(this.canDoRule());
  },

  result(can) {
    let props;
    if (can) {
      if (_.isArray(this.props.children)) {
        return <span>{this.props.children}</span>;
      }
      if (this.props.children) {
        props = _.clone(this.props);
        delete props.action;
        delete props.children;
        return React.cloneElement(this.props.children, props);
      }
      return this.props.fallback;
    }
    return this.props.fallback || this.props.message;
  }
}));

export function can(action, locationId) {
  const can = Security.get('can');
  if (!can) {
    return false;
  }
  const rule = ((locationId || Security.get('defaultLocation')) + action).replace(/\//g, '-');
  return can[rule];
}
